import {Directive, HostListener} from '@angular/core';
import {NgControl} from "@angular/forms";

@Directive({
  selector: '[appRemoveWhitespaceCharsOnPaste]'
})
export class RemoveWhitespaceCharsOnPasteDirective {

  constructor(private ngControl: NgControl) { }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    if (event && event.clipboardData) {
      const pasteValue = event.clipboardData.getData('text/plain');
      const transformValue = pasteValue.trim().replace(/\s/g, '') || '';
      this.ngControl.control?.setValue(transformValue);
    }
    event.preventDefault();
  }
}
